import { Check, ChevronDown, ChevronUp, Rocket, Zap, Shield, Mail } from 'lucide-react';

const WhyDifferent: React.FC = () => {
  const reasons = [
    { icon: <Zap className="text-cyan-400" />, text: "Written after 3M weekly impressions" },
    { icon: <Shield className="text-cyan-400" />, text: "Includes real examples (not fake imaginary ones)" },
    { icon: <Mail className="text-cyan-400" />, text: "Made by someone who doesn't have perfect English" },
    { icon: <Rocket className="text-cyan-400" />, text: "Focused on indie hackers, SaaS builders, devs" },
    { icon: <Check className="text-cyan-400" />, text: "Short, punchy, simple. Read it in 20 minutes." },
    { icon: <Check className="text-cyan-400" />, text: "No gatekeeping — everything I know is there." }
  ];

  return (
    <section className="bg-gray-900 text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
          Why this PDF is different
        </h2>
        
        <div className="grid md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => (
            <div key={index} className="flex items-center space-x-4 bg-black p-6 rounded-lg border border-cyan-400/20">
              <div className="flex-shrink-0">{reason.icon}</div>
              <span className="text-lg">{reason.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDifferent;